export default "__VITE_ASSET__b6bcd691__"